import { render, staticRenderFns } from "./PanelAddComment.vue?vue&type=template&id=5dd42e66&"
import script from "./PanelAddComment.vue?vue&type=script&lang=js&"
export * from "./PanelAddComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports